import { getMenus, getPages, getConfigLayout } from '@/services/dev';

export default {
  getMenus: async ({ commit, state }) => {
    const { data } = await getMenus(state.selectedPortal.portalId);

    commit('setMenus', data);
  },

  getPages: async ({ commit, state }) => {
    const { data } = await getPages(state.selectedPortal.portalId);

    commit('setPages', data);
  },

  getConfigLayout: async ({ commit, state }) => {
    const { data } = await getConfigLayout(state.selectedPortal.portalId);

    commit('setConfigLayout', data);
  },

  clearMenus: ({ commit }) => commit('clearMenus'),

  setSchema: ({ commit }, payload) => commit('setSchema', payload),

  setInitialSchema: ({ commit }, payload) => commit('setInitialSchema', payload),

  setModes: ({ commit }, payload) => commit('setModes', payload),

  setTypeOfPageEditing: ({ commit }, payload) => commit('setTypeOfPageEditing', payload),

  setConfirmPageChanges: ({ commit }, payload) => commit('setConfirmPageChanges', payload),

  setSelected: ({ commit }, payload) => commit('setSelected', payload),

  setSelectedTab: ({ commit }, payload) => commit('setSelectedTab', payload),

  setActiveTab: ({ commit }, payload) => commit('setActiveTab', payload),

  setCurrentMode: ({ commit }, payload) => commit('setCurrentMode', payload),

  setCurrentTemplate: ({ commit }, payload) => commit('setCurrentTemplate', payload),

  setSelectedPortal: ({ commit }, payload) => commit('setSelectedPortal', payload),

  setSelectedEnvironment: ({ commit }, payload) => commit('setSelectedEnvironment', payload),

  setSelectedPage: ({ commit }, payload) => commit('setSelectedPage', payload),

  setSelectedItem: ({ commit }, payload) => commit('setSelectedItem', payload),

  setParents: ({ commit }, payload) => commit('setParents', payload)
};
